import { render, staticRenderFns } from "./orderPrice.vue?vue&type=template&id=b802cf92&scoped=true&"
import script from "./orderPrice.vue?vue&type=script&lang=js&"
export * from "./orderPrice.vue?vue&type=script&lang=js&"
import style0 from "./orderPrice.vue?vue&type=style&index=0&id=b802cf92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b802cf92",
  null
  
)

export default component.exports